/*
 * LuxClub — Product option (color, size, etc.) selection UX.
 *
 * DISABLED at the user's request (restore native default selection,
 * remove forced red-flash prompt on Add to Cart).
 *
 * This file is intentionally left as a no-op stub instead of being
 * deleted, so the existing <script> reference to it keeps loading
 * without a 404. With this script inactive:
 *   - The first color/size option Shopify already pre-selects
 *     server-side now displays with its normal selected styling
 *     (checkmark on color swatches, red-bordered box on size/other
 *     button options) immediately on page load.
 *   - Add to Cart (including the mobile sticky bar, which forwards
 *     its click to this same button) is no longer intercepted, so it
 *     never scrolls up or flashes the option pickers.
 * No other file needs to change: the CSS rules that targeted the
 * "pending" state and the flash animation simply go unused because
 * this script no longer applies the classes they key off.
 */
(function () {
  'use strict';
  // Intentionally does nothing.
})();